export const Marquee = () => {
  const item = (
    <span className="font-display italic text-4xl md:text-6xl text-[#A39E9B]/40 whitespace-nowrap px-8 flex items-center gap-8">
      Zdrofit Warszawa Stegny
      <span className="text-[#FF6B6B] not-italic">•</span>
      ul. Mangalia 4
      <span className="text-[#FF6B6B] not-italic">•</span>
      Mokotów
      <span className="text-[#FF6B6B] not-italic">•</span>
    </span>
  );
  return (
    <div className="py-6 border-y border-[#2A2626] overflow-hidden">
      <div className="flex animate-marquee w-max">
        {item}
        {item}
        {item}
        {item}
      </div>
    </div>
  );
};
